import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/attendance-devices',
    name: 'attendance-device',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/attendance-device')
  }
]
